import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { CustomerApi } from '_api';
import { CATEGORY_CODES } from '_constants/categories';
import { handleError, handleResponse } from '_helpers/api';

export const getOrders = createAsyncThunk(
  'orders/getOrders',
  async function ({ customerId }, { getState, rejectWithValue }) {
    try {
      const { orders } = getState();
      const { page, count } = orders?.params || {};
      const response = await CustomerApi.getOrders({ customerId, category: CATEGORY_CODES.main, page, count });
      return handleResponse(response);
    } catch (error) {
      const processedError = handleError(error);
      return rejectWithValue(processedError);
    }
  }
);

const ordersSlice = createSlice({
  name: 'orders',
  initialState: {
    params: {
      page: 1,
      count: 100,
    },
    data: [],
    error: null,
    loading: false,
  },
  reducers: {
    refreshParams(state, action) {
      state.params = {
        ...state.params,
        ...action.payload,
      };
    },
    resetData(state) {
      state.data = [];
    },
    resetError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getOrders.pending, (state) => {
        state.error = null;
        state.loading = true;
      })
      .addCase(getOrders.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(getOrders.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      });
  },
});

export const { refreshParams, resetData, resetError } = ordersSlice.actions;

export default ordersSlice.reducer;
